var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { animated } from '@react-spring/web';
import { classNames } from '@shapeable/utils';
var cls = classNames('text-arc');
export var SvgTextArcDefaultProps = {
  ascending: true,
  debug: false,
  color: 'light',
  fontSize: 18
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TextStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _fontSize = _a._fontSize,
      _color = _a._color,
      isClickable = _a.isClickable;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: ", "px;\n      font-weight: 600;\n      fill: ", ";\n      cursor: ", ";\n\n      textPath {\n        fill: ", ";\n      }\n    "], ["\n      font-size: ", "px;\n      font-weight: 600;\n      fill: ", ";\n      cursor: ", ";\n\n      textPath {\n        fill: ", ";\n      }\n    "])), _fontSize, theme.COLOR(_color), isClickable ? 'pointer' : 'default', theme.COLOR(_color));
  })
});
// -------- Components -------->
var My = {
  Container: styled(animated.g)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Text: styled.text(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TextStyles)
};
export var SvgTextArc = function (props) {
  var className = props.className,
    suffix = props.suffix,
    marker = props.marker,
    debug = props.debug,
    style = props.style,
    id = props.id,
    r = props.r,
    ascending = props.ascending,
    fontSize = props.fontSize,
    color = props.color,
    children = props.children,
    x1 = props.x1,
    x2 = props.x2,
    y1 = props.y1,
    y2 = props.y2,
    onClick = props.onClick;
  var pathId = "".concat(id, "-path");
  var d = "M".concat(x1, " ").concat(y1, " A").concat(r, " ").concat(r, " 0 0 ").concat(ascending ? '1' : '0', " ").concat(x2, " ").concat(y2);
  return React.createElement(My.Container, {
    style: style,
    className: cls.name(className)
  }, React.createElement("defs", null, React.createElement("path", {
    id: pathId,
    d: d,
    fill: "#000",
    stroke: "#000"
  })), debug && React.createElement("path", {
    id: pathId,
    d: d,
    fill: "#00000099"
  }), React.createElement(My.Text, {
    onClick: onClick,
    isClickable: !!onClick,
    _color: color,
    _fontSize: fontSize
  }, React.createElement("textPath", {
    xlinkHref: "#".concat(pathId),
    startOffset: "50%",
    textAnchor: "middle"
  }, React.createElement("tspan", null, children), suffix, marker)));
};
SvgTextArc.cls = cls;
SvgTextArc.defaultProps = SvgTextArcDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;